import extend from '@/utils/vuex-extend';
import {table} from '@/vuex-extend';
import {fetchList} from '@/api/oms/refund';
import {wait} from '@/utils/wait';
import moment from "moment";

export default extend(table, {
	namespaced: true,
	state: {
		searchForm: {}
	},
	actions: {
		async getList({state, dispatch}, payload) {
			await wait(dispatch, 'oms.refund.list', async function () {
				const {searchForm} = state;
				const params = {}
				if(searchForm.select && searchForm.value){
					params[searchForm.select] = searchForm.value
				}
				const startTime = searchForm.time && searchForm.time[0] && Math.round(moment(searchForm.time[0].valueOf()) / 1000)
				const endTime = searchForm.time && searchForm.time[1] && Math.round(moment(searchForm.time[1].valueOf()) / 1000)
				await dispatch('getData', {
					caller: fetchList,
					options: {
						status: searchForm.status,
						...params,
						startTime,
						endTime,
						...payload
					}
				});
			})
		},
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/oms/refund/list.js